import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { PROJECT_SITE_INSPECTIONS_QUERY } from './useProjectSiteInspections';

const CREATE_SITE_INSPECTION_MUTATION = gql`
  mutation CreateSiteInspection($projectId: ID!) {
    createSiteInspection(projectId: $projectId) {
      siteInspection {
        id
        sequence
        displayLabel
      }
    }
  }
`;

export function useCreateSiteInspection(projectId: string) {
  const [mutation, { loading, error }] = useMutation(CREATE_SITE_INSPECTION_MUTATION, {
    refetchQueries: [
      { query: PROJECT_SITE_INSPECTIONS_QUERY, variables: { projectId, page: 1, limit: 20 } },
    ],
  });

  const createSiteInspection = async () => {
    const { data } = await mutation({ variables: { projectId } });
    return (data as any)?.createSiteInspection?.siteInspection;
  };

  return { createSiteInspection, loading, error };
}
